import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef, MatTableDataSource } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { FormSectionComponent } from '../../../../shared/components/form-ui/form-section/form-section.component';
import { ToggleOptionComponent } from '../../../../shared/components/form-ui/toggle-option/toggle-option.component';
import { ICreateCompany } from "./interfaces/create-company.interface";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { CompanyService } from "./company.service.service";
import { IUpdateCompany } from "./interfaces/update-company.interface";
import { PriceListService } from "../../master/price-list/price-list.service";
import { CurrencyService } from "../../master/currency/currency.service";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import CurrencyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/currency/currency.entity";
import TenantAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/tenant/tenant.entity";
import { TenantService } from "../tenant/tenant.service.service";
import CompanyApplicationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company-application/company-application.entity";
import { AddCompanyContactComponent } from "./company-contact-modal/company-contact.component";
import { CompanyContactService } from "./company-contact-modal/company-contact.service";
import { AddBusinessPartnerPhoneComponent } from "../../business-partners/business-partner/business-partner-phone-modal/business-partner-phone.component";
import { AddBusinessPartnerEmailComponent } from "../../business-partners/business-partner/business-partner-email-modal/business-partner-email.component";
import { CompanyPhoneService } from "./company-phone-modal/company-email.service";
import { CompanyEmailService } from "./company-phone-modal/company-phone.service";
import { AddBusinessPartnerAddressComponent } from "../../business-partners/business-partner/business-partner-address-modal/business-partner-address.component";
import { CompanyAddressService } from "./company-address-modal/company-address.service";
import { AddCompanyHolidayComponent } from "./company-holiday-modal/company-holiday.component";
import { CompanyHolidayService } from "./company-holiday-modal/company-holiday.service";
import { DeleteConfirmationComponent } from "../../business-partners/business-partner/delete-modal/delete-modal.component";
import { CompanyLogoDialogComponent } from "./company-logo-dialog/company-logo-dialog.component";
import { CompanyLogoPreviewComponent } from "./company-logo-preview/company-logo-preview.component";
import { ICompanyLogoData } from "./interfaces/company-logo-data.interface";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { CompanyContactPhoneService } from "./company-contact-modal/company-contact-email.service";
import { CompanyContactEmailService } from "./company-contact-modal/company-contact-phone.service";
import { MatBadgeModule } from "@angular/material/badge";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { DocumentTypeService } from "../../document/document-type/document-type.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import DocumentTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-type/document-type.entity";
import { BusinessPartnerCreationModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/business-partner-creation-mode.enum";
import { LoadCalculationModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/load-calculation-mode.enum";
import { DecimalConfigService } from "app/services/decimal-config.service";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import DocumentClassAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/document-class.entity";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { REFERENCE_TYPE_LABELS } from "app/common/enums/reference-type.enum";
import { ErpFieldSourceEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/erp-field-source.enum";
import { CompanyFormConfigComponent } from "./company-form-config/company-form-config.component";
import { EntityEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/entity.enum";
import { BonusPriceBehaviorEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/bonus-price-behavior.enum";
import { UserFieldsCatalogComponent } from "./user-fields-catalog/user-fields-catalog.component";
import { CompanyVersionConfigComponent } from "./company-version-config/company-version-config.component";

@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  standalone: true,
  providers: [
    DatePipe,
    DecimalPipe,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  styleUrl: "./company.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    HoverMenuDirective,
    StatusFiltersComponent,
    FormSectionComponent,
    ToggleOptionComponent,
    FilterComponent,
    MatTooltipModule
  ],
})
export class CompanyComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  isSync = environment.isSync; //sincroniza por lo tanto no debe haber external

  displayedColumns: string[] = ["logo", "name", "RTN", "statusId", "actions"];
  displayedColumnsApplications: string[] = ["name", "statusId", "actions"];
  displayedColumnsEmail: string[] = ["email", "statusId", "actions"];
  displayedColumnsPhone: string[] = ["type", "prefix", "statusId", "actions"];
  displayedColumnsAddress: string[] = [
    "name",
    "address",
    "statusId",
    "actions",
  ];
  displayedColumnsContact: string[] = [
    "fullName",
    "emails",
    "phones",
    "statusId",
    "actions",
  ];
  displayedColumnsDocument: string[] = ["code", "name", "actions"];
  currentCreateCompany: ICreateCompany = this.initializeCreateCompany();
  permissionsMap: { [key: string]: boolean } = {};
  originalCompany: CompanyAttributes | undefined;
  currentUpdateCompany: CompanyAttributes | undefined;
  dataSource: CompanyAttributes[] = [];

  daysList: { day: string; value: number }[] = [
    { day: "LUNES", value: 1 },
    { day: "MARTES", value: 2 },
    { day: "MIÉRCOLES", value: 3 },
    { day: "JUEVES", value: 4 },
    { day: "VIERNES", value: 5 },
    { day: "SÁBADO", value: 6 },
    { day: "DOMINGO", value: 7 },
  ];

  bonusPriceBehaviorOptions = [
    { label: 'Precio cero', value: BonusPriceBehaviorEnum.PRECIO_CERO },
    { label: 'Precio de costo', value: BonusPriceBehaviorEnum.PRECIO_COSTO },
  ];

  priceList: PriceListAttributes[] = [];
  discountList: PriceListAttributes[] = [];
  currencyList: CurrencyAttributes[] = [];
  tenantList: TenantAttributes[] = [];
  documentTypeList: DocumentTypeAttributes[] = [];
  listFilterdocumentTypeList: DocumentTypeAttributes[] = [];
  aplicacionList: CompanyApplicationAttributes[] = [];

  dataSourceDocument = new MatTableDataSource<DocumentTypeAttributes>([]);
  filtereddataSourceDocument = new MatTableDataSource<DocumentTypeAttributes>(
    []
  );

  searchQuery: string = "";
  searchText = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;
  companySaved = false;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  documentClassList: DocumentClassAttributes[] = [];
  filteredDocumentClassList: DocumentClassAttributes[] = [];

  documentClassListReturn: DocumentClassAttributes[] = [];
  filteredDocumentClassListReturn: DocumentClassAttributes[] = [];

  //BUSCADOR
  searchSubscription: Subscription;
  modeList: string[] = Object.values(BusinessPartnerCreationModeEnum).filter(
    (value) => typeof value === "string"
  );
  calcList: string[] = Object.values(LoadCalculationModeEnum).filter(
    (value) => typeof value === "string"
  );
  //Para filtros
  selectedStatuses: number[] = [];

  // Reference types for Finance tab
  referenceTypes = Object.values(ErpFieldSourceEnum);
  referenceTypeLabels = REFERENCE_TYPE_LABELS;
  constructor(
    private readonly companyService: CompanyService,
    private readonly contactService: CompanyContactService,
    private readonly companyHolidayService: CompanyHolidayService,
    private readonly priceService: PriceListService,
    private readonly currencyService: CurrencyService,
    private readonly tenantService: TenantService,
    private readonly phoneService: CompanyPhoneService,
    private readonly emailService: CompanyEmailService,
    private readonly addressService: CompanyAddressService,
    private emailContactService: CompanyContactEmailService,
    private phoneContactService: CompanyContactPhoneService,
    private documentTypeService: DocumentTypeService,
    private readonly searchService: SearchService,
    private decimalConfigService: DecimalConfigService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private decimalPipe: DecimalPipe,
    private documentClassService: DocumentClassService
  ) {}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.fetchAllPrice();
    this.fetchAllDiscountPrice();
    this.fetchAllCurrency();
    this.fetchAllTenant();
    this.findAllWithCount();
  }

  private fetchAllDocument(): void {
    const idsToFetch = DocumentTypeEnum.DOCUMENTO_MERMA;

    this.documentClassService.findToComboBoxByCode(idsToFetch).subscribe({
      next: (res) => {
        this.documentClassList = res.data;
        this.filteredDocumentClassList = this.documentClassList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener clases de documentos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllDocumentReturn(): void {
    const idsToFetch = DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO;

    this.documentClassService.findToComboBoxByCode(idsToFetch).subscribe({
      next: (res) => {
        this.documentClassListReturn = res.data;
        this.filteredDocumentClassListReturn =
          this.documentClassListReturn.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message ||
            "Error al obtener clases de documentos devolución.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  filterDocumentClasses(search: string): any[] {
    if (!search) {
      return this.documentClassList;
    }
    search = search.toLowerCase();
    return this.documentClassList.filter(
      (dc) =>
        dc.code.toLowerCase().includes(search) ||
        dc.name.toLowerCase().includes(search)
    );
  }

  private getTypeDocuments(): void {
    this.documentTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.documentTypeList = res.data;
        this.listFilterdocumentTypeList = this.documentTypeList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error tipos de documentos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsMaterial(event) {
    if (!this.documentTypeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterdocumentTypeList = this.documentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterdocumentTypeList = this.documentTypeList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  addRelatedDocument() {
    const newRelatedMaterialId = (this.currentUpdateCompany as any)
      .docTypesToSendToERPatCloseTrip;
    const isDuplicate = this.dataSourceDocument.data.some(
      (material) => material._id === newRelatedMaterialId._id.toString()
    );
    if (!isDuplicate) {
      let auxData = this.dataSourceDocument.data.slice();
      auxData.push(newRelatedMaterialId);
      this.dataSourceDocument.data = auxData;
      this.filtereddataSourceDocument.data = this.dataSourceDocument.data;
      (this.currentUpdateCompany as any).docTypesToSendToERPatCloseTrip = null;
    } else {
      this.snackBar.open("El documento ya está agregado", "Cerrar", {
        duration: 3000,
      });
    }
  }

  addRelatedDocumentCreate() {
    const newRelatedMaterialId = (this.currentCreateCompany as any)
      .docTypesToSendToERPatCloseTrip;
    const isDuplicate = this.dataSourceDocument.data.some(
      (material) => material._id === newRelatedMaterialId._id.toString()
    );
    if (!isDuplicate) {
      let auxData = this.dataSourceDocument.data.slice();
      auxData.push(newRelatedMaterialId);
      this.dataSourceDocument.data = auxData;
      this.filtereddataSourceDocument.data = this.dataSourceDocument.data;
      (this.currentCreateCompany as any).docTypesToSendToERPatCloseTrip = null;
    } else {
      this.snackBar.open("El documento ya está agregado", "Cerrar", {
        duration: 3000,
      });
    }
  }

  deleteItem(i: number): void {
    const itemToDelete = this.dataSourceDocument.data[i];
    this.dataSourceDocument.data = this.dataSourceDocument.data.filter(
      (_, index) => index !== i
    );
    this.filtereddataSourceDocument.data =
      this.filtereddataSourceDocument.data.filter(
        (item) => item._id !== itemToDelete._id
      );
    this.cdr.detectChanges();
  }

  private initializeCreateCompany(): ICreateCompany {
    return {
      NIT: "",
      name: "",
      UMPActive: false,
      ERPActive: false,
      numberOfDecimals: null,
      numberUsersAprroveBusinessPartner: null,
      useGPSInCSMmobile: false,
      distanceBetween: {
        sellerToCustomer: 0,
        courierToStore: 0,
        courierToCustomer: 0,
      },
      currencyBaseId: "",
      priceListId: "",
      discountListId: "",
      validateStockInRouting: true,
      groupStockByDateInRouting: false,
      totalMonthsToGroupStockInRouting: 0,
      monthsToGroupStockInRouting: 0,
      contacts: [],
      addresses: [],
      phones: [],
      emails: [],
      //holidays: [], TODO HOLIDAYS
      isTaxIncluded: false,
      isDisplayItemTax: false,
      isDisplayImages: true,
      maximumConsumptionOfFinalConsumer: 0,
      maximumConsumptionOfEventualCustomer: 0,
      docTypesToSendToERPatCloseTrip: [],
      emissionPointSeriesLength: 20, // Valor por defecto
      creditNoteField: null,
      advancePaymentField: null,
      accountStatementReferenceField: null,
      loadingAssistantEnableZeroPadding: false,
      loadingAssistantMaterialZeroPaddingSize: 0,
      loadingAssistantCustomerPaddingSize: 0,
      loadingAssistantSubRoutePaddingSize: 0,
      isAvailableTripPurge: false,
      documentNumberLength: 8,
      materialAppDisplayConfig: {
        showRelatedProducts: false,
        showBarcode: false,
        showScalePrice: false,
        showShortExpiryPrice: false,
        showUnitEquivalence: false,
        showStockAvailable: false,
        showMinimumSale: false,
        showRecipientsCount: false,
        showDesiredSaleQty: false
      },
      useMaterialAppDisplayConfig: false,
      sendOrderModificationsToERP: false,
      allowSyncOrdersInInventoryDistribution:false,
      payDecimalView: 0,
      payDecimalWork: 0
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  private fetchAllPrice(): void {
    this.priceService.findToComboBoxPriceList().subscribe({
      next: (res) => {
        this.priceList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener listas de precios.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllDiscountPrice(): void {
    this.priceService.findToComboBoxDiscountList().subscribe({
      next: (res) => {
        this.discountList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener descuentos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllCurrency(): void {
    this.currencyService.findToComboBox().subscribe({
      next: (res) => {
        this.currencyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener la moneda.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllTenant(): void {
    this.tenantService.findToComboBox().subscribe({
      next: (res) => {
        this.tenantList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener tenant.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  // private fetchAllApps(): void {
  //   this.appsService.findToComboBox().subscribe({
  //     next: (res) => {
  //       this.aplicacionList = res.data;
  //     },
  //     error: (err) => {
  //     },
  //   });
  // }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    // const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    let filter: IFilters = {
      status: this.selectedStatuses ? this.selectedStatuses : null,
    };

    this.companyService
      .findAllWithCount(
        {
          currentPage: pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof CompanyAttributes {
    const validSortFields: (keyof CompanyAttributes)[] = ["id", "name"];
    return validSortFields.includes(this.sort.active as keyof CompanyAttributes)
      ? (this.sort.active as keyof CompanyAttributes)
      : "id";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      }
    );
  }

  trackByFn(index: number, item: CompanyAttributes): string {
    return item._id.toString();
  }

  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }

  openContactModal(existingData?) {
    this.dialogRefAdd = this.dialog.open(AddCompanyContactComponent, {
      width: "90vw",
      maxWidth: "800px",
      data: {
        ...existingData,
        companyId: this.currentUpdateCompany._id,
      },
      disableClose: true,
    });

    this.dialogRefAdd.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateContact(result);
        } else {
          this.createContact(result);
        }
      }
    });
  }

  getContacts() {
    this.contactService
      .findByCompanyId(this.currentUpdateCompany._id.toString())
      .subscribe((data) => {
        if (this.currentCreateCompany) {
          this.currentCreateCompany.contacts = data?.data.filter(
            (res) => !res._deleted
          );
        }
        this.currentUpdateCompany.contacts = data?.data.filter(
          (res) => !res._deleted
        );
        this.paginator.length = this.totalItems;
      });
  }

  createContact(result): void {
    this.contactService
      .createEmbedded(this.currentUpdateCompany._id.toString(), result)
      .subscribe({
        next: (res) => {
          if (result.emails && result.emails.length > 0) {
            result.emails.forEach((email) => {
              this.emailContactService
                .createEmbedded2d(
                  this.currentUpdateCompany._id.toString(),
                  res.data._id.toString(),
                  email
                )
                .subscribe({
                  next: () => {
                    this.getContacts();
                  },
                  error: (err) => {
                    this.snackBar.open(
                      err.error.message || "Error al crear el correo",
                      "Cerrar",
                      { duration: 3000 }
                    );
                  },
                });
            });
          }

          // Verificar si existen teléfonos antes de iterar
          if (result.phones && result.phones.length > 0) {
            result.phones.forEach((phone) => {
              this.phoneContactService
                .createEmbedded2d(
                  this.currentUpdateCompany._id.toString(),
                  res.data._id.toString(),
                  phone
                )
                .subscribe({
                  next: () =>
                    this.snackBar.open("Teléfono registrado", "Cerrar", {
                      duration: 5000,
                    }),
                  error: (err) => {
                    this.snackBar.open(
                      err.error.message || "Error al crear el teléfono",
                      "Cerrar",
                      { duration: 3000 }
                    );
                  },
                });
            });
          }

          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }
  //actualizar id compañia, id contacto, id del telefono a modificar, cuerpo
  updateContact(result): void {
    this.contactService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: (res) => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          // this.getContacts();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  openDeleteContact(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteContact(item));
  }

  deleteContact(item: any): void {
    this.contactService
      .deleteEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Contacto eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getContacts();
      });
  }

  onStatusChangeContact(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedCompanyContact: any = {
      ...item,
      statusId: updatedStatusId,
    };
    this.contactService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        updatedCompanyContact
      )
      .subscribe({
        next: () => {
          this.getContacts();
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.getContacts();
        },
      });
  }

  openEmailModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerEmailComponent, {
      width: "90vw",
      maxWidth: "450px",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateEmail(result);
        } else {
          this.createEmail(result);
        }
      }
    });
  }

  createEmail(result): void {
    this.emailService
      .createEmbedded(this.currentUpdateCompany._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.emailService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.emails = data?.data;
              if (this.currentCreateCompany) {
                this.currentCreateCompany.emails = data?.data;
              }
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }
  updateEmail(result): void {
    this.emailService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.emailService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  openDeleteEmail(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteEmail(item));
  }

  deleteEmail(item: any): void {
    this.emailService
      .deleteEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Correo eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.emailService
          .findByCompanyId(this.currentUpdateCompany._id.toString())
          .subscribe((data) => {
            this.currentUpdateCompany.emails = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  onStatusChangeEmail(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updateCompanyEmail: any = {
      ...item,
      statusId: updatedStatusId,
    };
    this.emailService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        updateCompanyEmail
      )
      .subscribe({
        next: () => {
          this.emailService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.emailService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  openPhoneModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerPhoneComponent, {
      width: "95vw",
      maxWidth: "600px",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updatePhone(result);
        } else {
          this.createPhone(result);
        }
      }
    });
  }

  createPhone(result): void {
    this.phoneService
      .createEmbedded(this.currentUpdateCompany._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.phoneService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.phones = data?.data;
              if (this.currentCreateCompany) {
                this.currentCreateCompany.phones = data?.data;
              }
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updatePhone(result): void {
    this.phoneService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.phoneService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  openDeletePhone(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deletePhone(item));
  }

  deletePhone(item: any): void {
    this.phoneService
      .deleteEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Telefono eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.phoneService
          .findByCompanyId(this.currentUpdateCompany._id.toString())
          .subscribe((data) => {
            this.currentUpdateCompany.phones = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  onStatusChangePhone(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updateCompanyPhone: any = {
      ...item,
      statusId: updatedStatusId,
    };
    this.phoneService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        updateCompanyPhone
      )
      .subscribe({
        next: () => {
          this.phoneService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.phoneService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }
  cp = "company";
  openAddressModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerAddressComponent, {
      width: "90vw",
      maxWidth: "700px",
      data: {
        ...existingData,
        company: this.cp,
        companyId: this.currentUpdateCompany._id,
      },
      disableClose: true,
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     if (existingData) {
    //       this.updateAddress(result);
    //     } else {
    //       this.createAddress(result);
    //     }
    //   }
    // });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.addressService
          .findByCompanyId(this.currentUpdateCompany._id.toString())
          .subscribe((data) => {
            this.currentUpdateCompany.addresses = data?.data;
            this.paginator.length = this.totalItems;
          });
      }
    });
  }

  // createAddress(result): void {
  //   this.addressService
  //     .createEmbedded(this.currentUpdateCompany._id.toString(), result)
  //     .subscribe({
  //       next: () => {
  //         this.snackBar.open("Registro creado con éxito", "Cerrar", {
  //           duration: 3000,
  //         });
  //         this.addressService
  //           .findByCompanyId(this.currentUpdateCompany._id.toString())
  //           .subscribe((data) => {
  //             this.currentUpdateCompany.addresses = data?.data;
  //             if (this.currentCreateCompany){
  //               this.currentCreateCompany.addresses = data?.data;
  //             }
  //             this.paginator.length = this.totalItems;
  //           });
  //       },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al crear el registro",
  //           "Cerrar",
  //           { duration: 3000 }
  //         );
  //       },
  //     });
  // }

  // updateAddress(result): void {
  //   this.addressService
  //     .updateEmbedded(
  //       this.currentUpdateCompany._id.toString(),
  //       result._id.toString(),
  //       result
  //     )
  //     .subscribe({
  //       next: () => {
  //         this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
  //           duration: 3000,
  //         });
  //         this.addressService
  //           .findByCompanyId(this.currentUpdateCompany._id.toString())
  //           .subscribe((data) => {
  //             this.currentUpdateCompany.addresses = data?.data;
  //             this.paginator.length = this.totalItems;
  //           });
  //       },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al actualizar el registro",
  //           "Cerrar",
  //           { duration: 3000 }
  //         );
  //       },
  //     });
  // }

  //
  openDeleteAddress(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteAddress(item));
  }

  deleteAddress(item: any): void {
    this.addressService
      .deleteEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Contacto eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.addressService
          .findByCompanyId(this.currentUpdateCompany._id.toString())
          .subscribe((data) => {
            this.currentUpdateCompany.addresses = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  onStatusChangeAddress(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedCompanyAddress = {
      ...item,
      statusId: updatedStatusId,
    };
    this.addressService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        updatedCompanyAddress
      )
      .subscribe({
        next: () => {
          this.addressService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.addresses = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.addressService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              this.currentUpdateCompany.addresses = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }
  //pendiente
  openHolidayModal(existingData?) {
    const dialogRef = this.dialog.open(AddCompanyHolidayComponent, {
      width: "90vw",
      maxWidth: "700px",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateHoliday(result);
        } else {
          this.createHoliday(result);
        }
      }
    });
  }

  createHoliday(result): void {
    this.companyHolidayService
      .createEmbedded(this.currentUpdateCompany._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.companyHolidayService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              //this.currentUpdateCompany.holidays = data?.data; //TODO HOLIDAYS
              if (this.currentCreateCompany) {
                //this.currentCreateCompany.holidays = data?.data; //TODO HOLIDAYS
              }
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateHoliday(result): void {
    this.companyHolidayService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.companyHolidayService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              //this.currentUpdateCompany.holidays = data?.data; //TODO HOLIDAYS
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }
  //
  openDeleteHoliday(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteHoliday(item));
  }

  deleteHoliday(item: any): void {
    this.companyHolidayService
      .deleteEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Dia Festivo eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.companyHolidayService
          .findByCompanyId(this.currentUpdateCompany._id.toString())
          .subscribe((data) => {
            //this.currentUpdateCompany.holidays = data?.data; //TODO HOLIDAYS
            this.paginator.length = this.totalItems;
          });
      });
  }

  onStatusChangeHoliday(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updateCompanyHoliday: any = {
      ...item,
      statusId: updatedStatusId,
    };
    this.companyHolidayService
      .updateEmbedded(
        this.currentUpdateCompany._id.toString(),
        item._id.toString(),
        updateCompanyHoliday
      )
      .subscribe({
        next: () => {
          this.companyHolidayService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              //this.currentUpdateCompany.holidays = data?.data; //TODO HOLIDAYS
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.companyHolidayService
            .findByCompanyId(this.currentUpdateCompany._id.toString())
            .subscribe((data) => {
              //this.currentUpdateCompany.holidays = data?.data; //TODO HOLIDAYS
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  openCreateModal(): void {
    this.getTypeDocuments();
    this.fetchAllDocument();
    this.fetchAllDocumentReturn();
    this.currentCreateCompany = this.initializeCreateCompany();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      width: "95vw",
      maxWidth: "1200px",
      height: "95vh",
      maxHeight: "800px",
      disableClose: true,
    });
    this.dialogRefAdd
      .afterClosed()
      .subscribe((result) => result && this.createCompany());
  }

  openEditModal(company: CompanyAttributes): void {
    this.originalCompany = JSON.parse(JSON.stringify(company)); // Guardar snapshot original
    this.getTypeDocuments();
    this.fetchAllDocument();
    this.fetchAllDocumentReturn();

    const defaultKeys = ["name", "dni", "rtn", "commercialName", "address"];

    const permissionsMap = new Map(
      (company.permissions || []).map((p) => [p.key, p.enabled])
    );

    this.permissionsMap = {};
    defaultKeys.forEach((key) => {
      this.permissionsMap[key] = permissionsMap.get(key) ?? true;
    });

    this.currentUpdateCompany = {
      ...company,
      externalKeys: this.getCode(company)
        ? { code: this.getCode(company) }
        : { code: null },
      useGPSInCSMmobile: company.useGPSInCSMmobile ?? false,
      distanceBetween: {
        sellerToCustomer:
          Number(company.distanceBetween?.sellerToCustomer) || 0,
        courierToStore: Number(company.distanceBetween?.courierToStore) || 0,
        courierToCustomer:
          Number(company.distanceBetween?.courierToCustomer) || 0,
      },
      contacts: company.contacts?.filter((res) => !res._deleted),
      documentClassToWaste: company?.documentClassToWaste || null,
      documentClassToReturn: company?.documentClassToReturn || null,
      creditNoteField: company?.creditNoteField || null,
      advancePaymentField: company?.advancePaymentField || null,
      accountStatementReferenceField:
        company?.accountStatementReferenceField || null,
      loadingAssistantEnableZeroPadding:
        company?.loadingAssistantEnableZeroPadding || false,
      loadingAssistantMaterialZeroPaddingSize:
        company?.loadingAssistantMaterialZeroPaddingSize || 0,
      loadingAssistantCustomerPaddingSize:
        company?.loadingAssistantCustomerPaddingSize || 0,
      loadingAssistantSubRoutePaddingSize:
        company?.loadingAssistantSubRoutePaddingSize || 0,
      isAvailableTripPurge: company?.isAvailableTripPurge || false,
      documentNumberLength: company?.documentNumberLength || 8,
      useMaterialAppDisplayConfig: company?.useMaterialAppDisplayConfig ?? false
    };

    this.currentUpdateCompany.materialAppDisplayConfig = {
      showRelatedProducts: company.materialAppDisplayConfig?.showRelatedProducts ?? false,
      showBarcode: company.materialAppDisplayConfig?.showBarcode ?? false,
      showScalePrice: company.materialAppDisplayConfig?.showScalePrice ?? false,
      showShortExpiryPrice: company.materialAppDisplayConfig?.showShortExpiryPrice ?? false,
      showUnitEquivalence: company.materialAppDisplayConfig?.showUnitEquivalence ?? false,
      showStockAvailable: company.materialAppDisplayConfig?.showStockAvailable ?? false,
      showMinimumSale: company.materialAppDisplayConfig?.showMinimumSale ?? false,
      showRecipientsCount: company.materialAppDisplayConfig?.showRecipientsCount ?? false,
      showDesiredSaleQty: company.materialAppDisplayConfig?.showDesiredSaleQty ?? false
    };

    this.dataSourceDocument.data = [];
    this.filtereddataSourceDocument.data = [];
    if (
      this.currentUpdateCompany.docTypesToSendToERPatCloseTrip &&
      this.currentUpdateCompany.docTypesToSendToERPatCloseTrip.length > 0
    ) {
      this.documentTypeService
        .findToRelated(this.currentUpdateCompany.docTypesToSendToERPatCloseTrip)
        .subscribe((res) => {
          this.dataSourceDocument.data = res.data;
          this.filtereddataSourceDocument.data = res.data;
        });
    }
    // if (this.currentUpdateCompany) {
    //   const updatedUpdateCompany: IUpdateCompany = {
    //     ...this.currentUpdateCompany,
    //     priceListId: this.currentUpdateCompany.priceList._id.toString(),
    //     currencyBaseId: this.currentUpdateCompany.currencyBase._id.toString(),
    //     discountListId: this.currentUpdateCompany.discountList._id.toString(),
    //     applicationId: this.currentUpdateCompany.applications.map((a) => a._id.toString()),

    //     };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "95vw",
      maxWidth: "1200px",
      height: "95vh",
      maxHeight: "800px",
      disableClose: true,
    });
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      this.currentUpdateCompany = null;
      if (result) {
        this.updateCompany(company._id.toString());
      }
    });
  }

  formatNumber(value: number | null): string {
    if (value === null) return "";
    return this.decimalPipe.transform(value, "1.0-0") || "";
  }

  handleInputChange(
    value: string,
    model: "update" | "create",
    fieldName: string
  ): void {
    const numericValue = value ? Number(value.replace(/,/g, "")) : null;

    if (model === "update") {
      this.currentUpdateCompany[fieldName] = numericValue || 0;
    } else {
      this.currentCreateCompany[fieldName] = numericValue;
    }
  }

  createCompany(): void {
    const documentTypesId = this.dataSourceDocument.filteredData.map((item) =>
      item.code.toString()
    );
    const companyData = {
      ...this.currentCreateCompany,
      docTypesToSendToERPatCloseTrip: documentTypesId,
      currencyBaseId: this.currentCreateCompany.currencyBaseId
        ? this.currentCreateCompany.currencyBaseId
        : null,
      priceListId: this.currentCreateCompany.priceListId
        ? this.currentCreateCompany.priceListId
        : null,
      discountListId: this.currentCreateCompany.discountListId
        ? this.currentCreateCompany.discountListId
        : null,
      documentClassIdToReturn: this.currentCreateCompany.documentClassIdToReturn
        ? this.currentCreateCompany.documentClassIdToReturn
        : null,
      documentClassIdToWaste: this.currentCreateCompany.documentClassIdToWaste
        ? this.currentCreateCompany.documentClassIdToWaste
        : null,
      creditNoteField: this.currentCreateCompany.creditNoteField || null,
      advancePaymentField:
        this.currentCreateCompany.advancePaymentField || null,
      accountStatementReferenceField:
        this.currentCreateCompany.accountStatementReferenceField || null,
      loadingAssistantEnableZeroPadding:
        this.currentCreateCompany.loadingAssistantEnableZeroPadding || false,
      loadingAssistantMaterialZeroPaddingSize:
        this.currentCreateCompany.loadingAssistantMaterialZeroPaddingSize || 0,
      loadingAssistantCustomerPaddingSize:
        this.currentCreateCompany.loadingAssistantCustomerPaddingSize || 0,
      loadingAssistantSubRoutePaddingSize:
        this.currentCreateCompany.loadingAssistantSubRoutePaddingSize || 0,
      isAvailableTripPurge:
        this.currentCreateCompany.isAvailableTripPurge || false,
      materialAppDisplayConfig: this.currentCreateCompany.materialAppDisplayConfig,
      useMaterialAppDisplayConfig: this.currentCreateCompany.useMaterialAppDisplayConfig
    };

    if (companyData.useGPSInCSMmobile == false && companyData.distanceBetween)
      companyData.distanceBetween.sellerToCustomer = 0;

    const dataToSend: any = Object.entries(companyData).reduce(
      (acc, [key, value]) => {
        if (
          value !== "" &&
          value !== null &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          // Ignora cadenas vacías y arreglos vacíos
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    this.companyService.create(dataToSend).subscribe({
      next: (response) => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.currentUpdateCompany = response.data;
        this.companySaved = true;
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateCompany(id: string): void {
    if (this.currentUpdateCompany) {
      const documentTypesId = this.dataSourceDocument.filteredData.map((item) =>
        item.code.toString()
      );
      if (!this.currentUpdateCompany.externalKeys?.code) {
        this.currentUpdateCompany.externalKeys = null;
      }

      this.currentUpdateCompany.permissions = Object.entries(
        this.permissionsMap
      ).map(([key, enabled]) => ({ key, enabled }));
      const updatedCompany: IUpdateCompany = {
        ...this.currentUpdateCompany,
        id: this.currentUpdateCompany.id,
        docTypesToSendToERPatCloseTrip: documentTypesId,
        currencyBaseId: this.currentUpdateCompany.currencyBase
          ? this.currentUpdateCompany.currencyBase._id.toString()
          : null,
        priceListId: this.currentUpdateCompany.priceList
          ? this.currentUpdateCompany.priceList._id.toString()
          : null,
        discountListId: this.currentUpdateCompany.discountList
          ? this.currentUpdateCompany.discountList._id.toString()
          : null,
        // distanceBetween: this.currentUpdateCompany.distanceBetween ? this.currentUpdateCompany.distanceBetween:null,
        isTaxIncluded: this.currentUpdateCompany.isTaxIncluded,
        isDisplayItemTax: this.currentUpdateCompany.isDisplayItemTax,
        documentClassIdToReturn:
          this.currentUpdateCompany.documentClassToReturn?._id?.toString() ||
          null,
        documentClassIdToWaste:
          this.currentUpdateCompany.documentClassToWaste?._id?.toString() ||
          null,
        creditNoteField: this.currentUpdateCompany.creditNoteField || null,
        advancePaymentField:
          this.currentUpdateCompany.advancePaymentField || null,
        accountStatementReferenceField:
          this.currentUpdateCompany.accountStatementReferenceField || null,
        loadingAssistantEnableZeroPadding:
          this.currentUpdateCompany.loadingAssistantEnableZeroPadding || false,
        loadingAssistantMaterialZeroPaddingSize:
          this.currentUpdateCompany.loadingAssistantMaterialZeroPaddingSize ||
          0,
        loadingAssistantCustomerPaddingSize:
          this.currentUpdateCompany.loadingAssistantCustomerPaddingSize || 0,
        loadingAssistantSubRoutePaddingSize:
          this.currentUpdateCompany.loadingAssistantSubRoutePaddingSize || 0,
        isAvailableTripPurge:
          this.currentUpdateCompany.isAvailableTripPurge || false,
        materialAppDisplayConfig: this.currentUpdateCompany.materialAppDisplayConfig,
        useMaterialAppDisplayConfig: this.currentUpdateCompany.useMaterialAppDisplayConfig
      };
      if (
        updatedCompany.useGPSInCSMmobile === false &&
        updatedCompany.distanceBetween
      )
        updatedCompany.distanceBetween.sellerToCustomer = 0;

      const dataToSend: any = Object.entries(updatedCompany).reduce(
        (acc, [key, value]) => {
          if (
            value &&
            typeof value === "object" &&
            Object.keys(value).every(
              (k) => value[k] === null || value[k] === ""
            )
          ) {
            return acc;
          }
          if (
            value !== "" &&
            value !== null &&
            !(Array.isArray(value) && value.length === 0)
          ) {
            // Ignora cadenas vacías y arreglos vacíos
            acc[key] = value;
          }
          return acc;
        },
        {}
      );

      //Para enviar campos solo con cambios
      const changedFields = this.getChangedFields(
        this.originalCompany,
        updatedCompany
      );
      if (Object.keys(changedFields).length === 0) {
        this.snackBar.open("No hay cambios para actualizar", "Cerrar", {
          duration: 3000,
        });
        return;
      }

      this.companyService.update(id, changedFields).subscribe({
        next: (res) => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          if (
            updatedCompany.numberOfDecimals &&
            updatedCompany.id == environment.companyId
          ) {
            this.decimalConfigService.setDecimals(
              updatedCompany.numberOfDecimals || 2
            );
          }

          const active = this.companyService.getActiveCompany();
          if (active && res.data && active._id === res.data._id) {
            this.companyService.setActiveCompany(res.data);
          }

          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, company: CompanyAttributes): void {
    const originalStatusId = company.statusId;
    const updatedStatusId = event ? 1 : 0;

    const updatedCompany: any = {
      ...company,
      statusId: updatedStatusId,
    };

    this.companyService
      .update(company._id.toString(), updatedCompany)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          company.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(subRoute: CompanyAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: subRoute,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(subRoute._id.toString()));
  }

  delete(id: string): void {
    this.companyService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  // getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
  //   // return selectedCompanyIds.map(
  //     // (id) => this.companyList.find((group) => group._id.toString() === id)?.id
  //   // );
  // }

  onPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.priceList = this.priceList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  onDiscountPriceSelectionChange(discountListId: string): void {
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.discountList = this.discountList.find(
        (price) => price._id.toString() === discountListId
      )!;
    }
  }

  onCurrencySelectionChange(routeId: string): void {
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.currencyBase = this.currencyList.find(
        (route) => route._id.toString() === routeId
      )!;
    }
  }

  // onTenantSelectionChange(routeId: string): void {
  //   if (this.currentUpdateCompany)
  //     this.currentUpdateCompany.tenantId = this.tenantList.find(
  //       (route) => route._id.toString() === routeId
  //     )!;
  //   }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    // this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  getChangedFields(original: any, updated: any): any {
    const changed: any = {};

    for (const key of Object.keys(updated)) {
      const originalValue = original[key];
      const updatedValue = updated[key];

      const isObject =
        typeof updatedValue === "object" && updatedValue !== null;

      if (isObject && !Array.isArray(updatedValue)) {
        const nestedChanges = this.getChangedFields(
          originalValue || {},
          updatedValue
        );
        if (Object.keys(nestedChanges).length > 0) {
          changed[key] = nestedChanges;
        }
      } else if (Array.isArray(updatedValue)) {
        // Compare arrays by stringified values (can improve if needed)
        if (JSON.stringify(originalValue) !== JSON.stringify(updatedValue)) {
          changed[key] = updatedValue;
        }
      } else if (originalValue !== updatedValue) {
        changed[key] = updatedValue;
      }
    }

    return changed;
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  getModeLabel(mode: string): string {
    const labels = {
      [BusinessPartnerCreationModeEnum.AUTO_ON_APPROVAL]:
        "El cliente se crea automáticamente al aprobar el prospecto (Solo AVE)",
      [BusinessPartnerCreationModeEnum.ERP_MANAGED]:
        "Los nuevos prospectos se convierten en socios de negocio cuando después de crear en el ERP se completan los datos y se ejecuta la sincronización periódica",
      [BusinessPartnerCreationModeEnum.ERP_MANAGED_ON_EXTERNAL_KEY]:
        "Los nuevos prospectos se convierten en socios de negocio cuando se obtiene la clave externa desde el ERP",
      [BusinessPartnerCreationModeEnum.DIRECT_CREATION]:
        "Los nuevos prospectos se convierten en socio sin aprobacion(solo si el número de aprobaciones es 0)",
    };
    return labels[mode] || String(mode);
  }

  getCalculationLabel(mode: string): string {
    const labels = {
      [LoadCalculationModeEnum.BY_BASE_QUANTITY]: "Se calcula por UMB",
      [LoadCalculationModeEnum.BY_DIMENSIONS]:
        "Se calcula por dimensiones del material",
    };
    return labels[mode] || String(mode);
  }

  getAvailableReferenceTypes(
    excludeFields: string[] = []
  ): ErpFieldSourceEnum[] {
    const usedValues = new Set();

    if (this.currentCreateCompany) {
      if (
        !excludeFields.includes("creditNoteField") &&
        this.currentCreateCompany.creditNoteField
      ) {
        usedValues.add(this.currentCreateCompany.creditNoteField);
      }
      if (
        !excludeFields.includes("advancePaymentField") &&
        this.currentCreateCompany.advancePaymentField
      ) {
        usedValues.add(this.currentCreateCompany.advancePaymentField);
      }
      if (
        !excludeFields.includes("accountStatementReferenceField") &&
        this.currentCreateCompany.accountStatementReferenceField
      ) {
        usedValues.add(
          this.currentCreateCompany.accountStatementReferenceField
        );
      }
    }

    if (this.currentUpdateCompany) {
      if (
        !excludeFields.includes("creditNoteField") &&
        this.currentUpdateCompany?.creditNoteField
      ) {
        usedValues.add(this.currentUpdateCompany?.creditNoteField);
      }
      if (
        !excludeFields.includes("advancePaymentField") &&
        this.currentUpdateCompany?.advancePaymentField
      ) {
        usedValues.add(this.currentUpdateCompany?.advancePaymentField);
      }
      if (
        !excludeFields.includes("accountStatementReferenceField") &&
        this.currentUpdateCompany?.accountStatementReferenceField
      ) {
        usedValues.add(
          this.currentUpdateCompany?.accountStatementReferenceField
        );
      }
    }

    return this.referenceTypes.filter((type) => !usedValues.has(type));
  }

  clearCreditNoteField(): void {
    if (this.currentCreateCompany) {
      this.currentCreateCompany.creditNoteField = null;
    }
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.creditNoteField = null;
    }
  }

  clearAdvancePaymentField(): void {
    if (this.currentCreateCompany) {
      this.currentCreateCompany.advancePaymentField = null;
    }
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.advancePaymentField = null;
    }
  }

  clearAccountStatementReferenceField(): void {
    if (this.currentCreateCompany) {
      this.currentCreateCompany.accountStatementReferenceField = null;
    }
    if (this.currentUpdateCompany) {
      this.currentUpdateCompany.accountStatementReferenceField = null;
    }
  }

  openLogoPreviewModal(company: CompanyAttributes): void {
    if (!company.logoUrl) {
      this.snackBar.open("Esta compañía no tiene logo configurado", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    const logoData: ICompanyLogoData = {
      companyId: company._id.toString(),
      companyName: company.name,
      currentLogoUrl: company.logoUrl,
    };

    this.dialog.open(CompanyLogoPreviewComponent, {
      width: "600px",
      maxWidth: "90vw",
      data: logoData,
      disableClose: true,
    });
  }

  openLogoUpdateModal(company: CompanyAttributes): void {
    const logoData: ICompanyLogoData = {
      companyId: company._id.toString(),
      companyName: company.name,
      currentLogoUrl: company.logoUrl,
    };

    const dialogRef = this.dialog.open(CompanyLogoDialogComponent, {
      width: "600px",
      maxWidth: "90vw",
      data: logoData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.snackBar.open("Logo actualizado exitosamente", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount(); // Refrescar la lista
      }
    });
  }

  openFormConfig(company): void {
    this.dialog.open(CompanyFormConfigComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: {
        companyId: company._id,
        entities: [EntityEnum.BUSINESS_PARTNER],
      },
      disableClose: true,
    });
  }

  openFormConfigMaster(company): void {
    this.dialog.open(UserFieldsCatalogComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: {
        companyId: company._id,
      },
      disableClose: true,
    });
  }

  isModeDisabled(mode: string, company: CompanyAttributes): boolean {
    switch (mode) {
      case BusinessPartnerCreationModeEnum.AUTO_ON_APPROVAL:
        const approvedUsersCount =
          company?.numberUsersAprroveBusinessPartner || 0;
        // Bloquea si ERP activo o no hay aprobadores
        return company?.ERPActive || approvedUsersCount === 0;

      case BusinessPartnerCreationModeEnum.DIRECT_CREATION:
        const maxApprovers = company?.numberUsersAprroveBusinessPartner || 0;
        // Bloquea si ya hay aprobaciones o ERP activo
        return maxApprovers > 0 || company?.ERPActive;

      case BusinessPartnerCreationModeEnum.ERP_MANAGED:
      case BusinessPartnerCreationModeEnum.ERP_MANAGED_ON_EXTERNAL_KEY:
        // Bloquea si ERP inactivo
        return !company?.ERPActive;

      default:
        return false;
    }
  }

  openVersionConfig(company: CompanyAttributes): void {
    this.dialog.open(CompanyVersionConfigComponent, {
      width: "95vw",
      maxWidth: "800px",
      data: {
        companyId: company._id,
      },
      disableClose: true,
    });
  }
}
